<template>
    <div class="container-fluid pt-2">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="text-left py-3">
            <h3 class="text-weight-900">Stock Take</h3>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-6">
              <div>
        <form @submit.prevent="searchItems" class="form-inline">
          <div class="input-group w-100">
            <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemToRestock" placeholder="Search Item" />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="submit">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
          <p class="mt-3 pb-2"><small>Enter the item and select to add to list</small></p>
        </form>
      </div>
        </div>
        <div class="col-6">

<div class="form-group">

    <!-- Dropdown with checkboxes -->
    <div class="dropdown w-100">
      <button
        class="btn btn-light border border-dark form-control text-left"
        type="button"
        data-toggle="dropdown"
      >
        {{ dropdownLabel }}
      </button>
      <div class="dropdown-menu w-100 p-2" style="max-height: 250px; overflow-y: auto;">

        <!-- Select All -->
        <div class="form-check mb-2">
          <input
            type="checkbox"
            class="form-check-input"
            id="select-all"
            :checked="isAllSelected"
            :indeterminate.prop="isIndeterminate"
            @change="toggleSelectAll"
          >
          <label class="form-check-label" for="select-all">Select All</label>
        </div>

        <div class="dropdown-divider"></div>

        <!-- Individual categories -->
        <div
          v-for="category in allCategories"
          :key="category.id"
          class="form-check"
        >
          <input
            type="checkbox"
            class="form-check-input"
            :id="'cat-' + category.id"
            :value="category.id"
            v-model="selectedCategories"
          >
          <label class="form-check-label" :for="'cat-' + category.id">
            {{ category.name }}
          </label>
        </div>
      </div>
    </div>

    <p class="pb-2">
      <small>Select the categories you want to take stock on</small>
    </p>
  </div>
        </div>
      </div>

      <div style="margin-bottom: 5em;">
        <form @submit.prevent="submitStock(false)">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Current Count</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="item.is_service !== 1" v-for="(item, index) in filterItemsToRestock" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.product }}</td>
                <td><input @input="handleInputChange" type="number" class="form-control" v-model="item.stockCount"/></td>
              </tr>
            </tbody>
          </table>
          <div class="form-group">
            <button v-if="hasLoaded" type="submit" class="btn btn-primary btn-lg">Submit Stock Take</button>
            <a v-else type="submit" disabled>Loading .......</a>
          </div>
        </form>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';
import { debounce } from 'lodash';


  export default {

    data() {
      return {
        itemList: {},
        confirmIsNotComplete: true,
        hasLoaded:false,
        bulkRestock: {
          itemsToRestock: [],
        },

        searchItemToRestock: '',
        itemsSearched: {},
        stockTakeId:'',
        autoSaveTimer: null,
        debouncedSubmit: null,
        allCategories: {},
          selectedCategories: [],


      }
    },
    mounted() {
    this.getAllCategories()
    this.checkForRecent()


    this.debouncedSubmit = debounce(this.submitStock, 5000)



    this.autoSaveTimer = setInterval(() => {
      this.submitStock()
    }, 2 * 60 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.autoSaveTimer)
  },
    computed: {
      filterItemsToRestock() {
        return Object.values(this.itemList).filter(item => {
          return item.product && item.product.toLowerCase().includes(this.searchItemToRestock.toLowerCase());
        });
      },dropdownLabel() {
      if (this.selectedCategories.length === 0) {
        return "Select Categories";
      } else if (this.isAllSelected) {
        return "All Categories Selected";
      } else {
        return `${this.selectedCategories.length} Selected`;
      }
    },
    isAllSelected() {
      return this.selectedCategories.length === this.allCategories.length;
    },
    isIndeterminate() {
      return (
        this.selectedCategories.length > 0 &&
        this.selectedCategories.length < this.allCategories.length
      );
    }
    },
    methods: {
        handleInputChange() {

      this.debouncedSubmit()
    },
      async getAllProducts() {

        try {
            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.has('stock-take-id')) {
                const response = await axios.get('/api/only-products',{
          params: { categories: this.selectedCategories }
        });
                this.itemList = response.data;
                this.hasLoaded = true
            }
            else{
                const response = await axios.get('/api/get-stock-take-items',{params:{
                    id: urlParams.get('stock-take-id')
                }});
                    this.itemList = response.data;
                    this.hasLoaded = true

            }
        } catch (error) {
          console.error(error);
        }
      },
      async getAllCategories() {

        try {

                const response = await axios.get('/api/categories');
                    this.allCategories = response.data;
                       this.selectedCategories = this.allCategories.map(c => c.id);

                    this.hasLoaded = true
                    this.getAllProducts()


        } catch (error) {
          console.error(error);
        }
      },
      async checkForRecent() {

        try {

            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.has('stock-take-id')) {
                const response = await axios.get('/api/check-recent-autosave-stock-take');

                if(response.data.has_autosaved)
                {



                    this.$bvModal.msgBoxConfirm('There is a recent auto saved stock take list, You can choose to start a fresh or continue ', {
                    title: 'Continue with this list',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Continue with this',
                    cancelTitle: 'Start a fresh',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                    })
                    .then(value => {

                    if(value)
                    {

                                   // Append to URL without reloading
                        const newUrl = new URL(window.location.href)
                        newUrl.searchParams.set('stock-take-id', response.data.id)

                        window.history.replaceState({}, '', newUrl.toString())
                        window.location.reload()
                    }
                    else{
                        this .getAllCategories()

                    }
                    })
                    .catch(err => {
                        // An error occurred
                    })

                }
                else{
                    this.getAllProducts()
                }
            }else{
                this.getAllProducts()
            }

        } catch (error) {
          console.error(error);
        }
      },
      submitStock(isAutoSaved=true) {
        const urlParams = new URLSearchParams(window.location.search);
        axios.post('/api/submit-stock-count', {
          items: this.itemList,
          is_auto_save: isAutoSaved,
          id: urlParams.has('stock-take-id') ? urlParams.get('stock-take-id') : '',
        }).then(response => {
          if(response.status === 200)
        {
            if(isAutoSaved === false)
        {
            this.$toasts.push(
            {
                    type: 'success',
                    message: "Stock Take submitted successfully",
              });
          setTimeout( ()=>{
             window.location.href='/inventory'
            },1000)
        }
        else{

            const urlParams = new URLSearchParams(window.location.search);
            if (!urlParams.has('stock-take-id')) {
                this.stockTakeId = response.data.id

                // Append to URL without reloading
                const newUrl = new URL(window.location.href)
                newUrl.searchParams.set('stock-take-id', this.stockTakeId)

                window.history.replaceState({}, '', newUrl.toString())
                } else {
                this.stockTakeId = urlParams.get('stock-take-id')
                }

        }


        }
        }).catch(error => {

          this.$toasts.push(
            {
                    type: 'error',
                    message: error
              });
        });
      },
      searchItems() {
        // Implement your search functionality here
      },
      searchItemAddToList(item) {
        if (!this.bulkRestock.itemsToRestock.includes(item)) {
          this.bulkRestock.itemsToRestock.push(item);
          this.itemsSearched = {};
        } else {
          const index = this.bulkRestock.itemsToRestock.indexOf(item);
          if (index !== -1) {
            this.bulkRestock.itemsToRestock.splice(index, 1);
            this.itemsSearched = {};
          }
        }
      },
        toggleSelectAll(e) {
      if (e.target.checked) {
        this.selectedCategories = this.allCategories.map(c => c.id);
      } else {
        this.selectedCategories = [];
      }
    }
  },
    watch: {

  selectedCategories() {
    this.getAllProducts();
  }
},
  }
  </script>

<style>
.list-search-item {
  margin: 0.5em 0 0.5em 0;
  padding: 0;
}
small{
    font-size: 11px !important;
}
#customdropzone{


    min-width: 320px;
    min-height: 180px;

  }


</style>
